export default __webpack_public_path__ + "static/media/bestmate-logo-white.b28a6e07.png";